module.exports = __webpack_public_path__ + "static/media/photo_009.a28538e8.JPG";